import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UsersService, Organ, Application, UserAttributeRequest } from 'src/app/services/users.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { TokenService } from 'src/app/services/token.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';


interface AclResponse {
  acl: string;
  ente: string;
  nomeEnte: string;
}

@Component({
  selector: 'app-crea-utente',
  templateUrl: './crea-utente.component.html',
  styleUrls: ['./crea-utente.component.css']
})
export class CreaUtenteComponent implements OnInit {
  creaUtenteForm: FormGroup;
  isLoading: boolean = false;
  loggedUserOffice: string;

  private tenantId: number;
  private appId: number;
  private appCode: string = "GestioneEmergenze";
  private offices: Organ[];
  private applications: Application[];
  private activeOfficeId: number;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private usersService: UsersService,
    private authService: AuthenticationService,
    private alertsCenterService: AlertsCenterService,
    private tokenService: TokenService,
    private http: HttpClient
  ) { }

  async ngOnInit(): Promise<void> {
    this.creaUtenteForm = this.formBuilder.group({
      codiceFiscale: ['', Validators.required],
      nome: ['', Validators.required],
      cognome: ['', Validators.required],
      /*provinciaEnte: ['', Validators.required],
      tipologiaEnte: ['', Validators.required],
      codiceIstat: ['', Validators.required],
      descrizione: [''],
      indirizzoEnte: ['', Validators.required],
      capEnte: ['', Validators.required],
      cittaEnte: ['', Validators.required],
      faxEnte: [''],
      pecEnte: ['', Validators.required],*/
      userDomain: ['Regione Veneto', Validators.required]
    });


    try {
      //Recupera il codice ente dell'utente loggato.
      const aclResponse: AclResponse = await this.getEnteCode().toPromise();
      this.loggedUserOffice = aclResponse.ente;

      //const loggedUserOrgan: Organ = await this.usersService.getOrganByNodeCode(this.loggedUserOffice).toPromise();
      const offices: Organ[] = await this.usersService.getTenantOffices().toPromise();
      const loggedUserOrgan = offices.find(o => o.nodeCode === this.loggedUserOffice);

      /*if (!loggedUserOrgan || !loggedUserOrgan.attributes) {
        throw new Error('Impossibile trovare gli attributi dell\'ufficio nel backend.');
      }*/
      if (!loggedUserOrgan) {
        throw new Error('Impossibile trovare l\'ufficio corrispondente nel backend.');
      }


      //Salva l'id numerico dell'ufficio per la chiamata 'setTenantUserOffices'
      this.activeOfficeId = loggedUserOrgan.organId;
      /*
      //Mappa gli attributi e precompila la form
      const attributesMap = new Map<string, string>();
      loggedUserOrgan.attributes.forEach(attr => {
        attributesMap.set(attr.attributeName, attr.attributeValue);
      });

      const defaultEnteData = {
        provinciaEnte: attributesMap.get('Provincia Ente') || '',
        tipologiaEnte: attributesMap.get('Tipologia Ente') || '',
        codiceIstat: attributesMap.get('Codice ISTAT') || '',
        descrizione: attributesMap.get('Descrizione') || loggedUserOrgan.description,
        indirizzoEnte: attributesMap.get('Indirizzo Ente') || '',
        capEnte: attributesMap.get('CAP Ente') || '',
        cittaEnte: attributesMap.get('Città Ente') || '',
        faxEnte: attributesMap.get('Fax Ente') || '',
        pecEnte: attributesMap.get('Pec Ente') || '',
      };

      this.creaUtenteForm.patchValue(defaultEnteData);
      */

      //Estrae e salva il tenantId recuperato dinamicamente dall'API
      this.tenantId = loggedUserOrgan.tenant.tenantId;

      //Recupera l'elenco delle applicazioni e trova l'appId corretto
      //this.applications = await this.usersService.getApplications().toPromise();
      //const currentApp = this.applications.find(app => app.applCode === this.appCode);
      const applications: Application[] = await this.usersService.getApplications().toPromise();
      const currentApp = applications.find(app => app.applCode === this.appCode);

      if (!currentApp) {
        throw new Error(`Impossibile trovare l'applicazione con il codice: ${this.appCode}.`);
      }
      this.appId = currentApp.applId;

    } catch (error) {
      console.error("Errore nel recupero dell'ACL dell'utente, del tenantId o dell'appId:", error);
      this.alertsCenterService.showAlert({
        message: `Errore nel recupero dei dati di sistema. Impossibile procedere.`,
        type: 'danger',
        autoClosable: false
      });
    }
  }


  // Metodo per recuperare il codice ente dell'utente loggato.
  private getEnteCode() {
    return this.tokenService.getJwtMyProfile().pipe(
      catchError(error => {
        this.alertsCenterService.showAlert({
          message: `Errore nel recupero del JWT.`,
          type: 'danger',
          autoClosable: false
        });
        return throwError(error);
      }),
      mergeMap(token => {
        const headers = new HttpHeaders({
          'X-MyProfile-Token': token || ''
        });
        return this.http.get<AclResponse>(`${environment.urls.base}/utente/acl-utente`, { headers });
      })
    )
  }


  async onSalva(): Promise<void> {
    this.creaUtenteForm.markAllAsTouched();

    if (this.creaUtenteForm.valid) {
      this.isLoading = true;

      if (!this.loggedUserOffice || !this.tenantId || !this.appId /*|| !this.activeOfficeId*/) {
        this.alertsCenterService.showAlert({
          message: `Dati di sistema non disponibili. Riprova.`,
          type: 'danger',
          autoClosable: false
        });
        this.isLoading = false;
        return;
      }

      try {
        const formData = this.creaUtenteForm.value;
        const userRequest = {
          userCode: formData.codiceFiscale,
          userName: formData.nome,
          userSurname: formData.cognome,
          userDomain: formData.userDomain
        };

        //Chiama createUser
        //const userCreated = await this.usersService.createUser(formData).toPromise();
        const userCreated = await this.usersService.createUser(userRequest).toPromise();
        const newUserId = userCreated.userId;

        if (!newUserId) {
          throw new Error('L\'ID utente non è stato restituito dalla chiamata createUser.');
        }

        /*
        // Prepara gli attributi da inviare.
        const attributes: UserAttributeRequest[] = [
          { attributeName: 'provinciaEnte', attributeValue: formData.provinciaEnte },
          { attributeName: 'tipologiaEnte', attributeValue: formData.tipologiaEnte },
          { attributeName: 'codiceIstat', attributeValue: formData.codiceIstat },
          { attributeName: 'descrizione', attributeValue: formData.descrizione },
          { attributeName: 'indirizzoEnte', attributeValue: formData.indirizzoEnte },
          { attributeName: 'capEnte', attributeValue: formData.capEnte },
          { attributeName: 'cittaEnte', attributeValue: formData.cittaEnte },
          { attributeName: 'faxEnte', attributeValue: formData.faxEnte },
          { attributeName: 'pecEnte', attributeValue: formData.pecEnte }
        ];

        //Chiama addUserAttributes per salvare gli attributi
        await this.usersService.addUserAttributes(newUserId, attributes).toPromise();
        */

        //Chiama setTenantUser
        await this.usersService.setTenantUser(newUserId, this.tenantId).toPromise();

        //Chiama setTenantUserApp
        await this.usersService.setTenantUserApp(newUserId, this.tenantId, this.appId).toPromise();

        /*
        //Recupera l'ID numerico dell'ufficio dal backend
        const offices: Organ[] = await this.usersService.getTenantOffices().toPromise();
        const loggedUserOrgan = offices.find(o => o.nodeCode === this.loggedUserOffice);

        if (!loggedUserOrgan) {
          throw new Error('Impossibile trovare l\'ufficio corrispondente nel backend.');
        }*/

        if (!this.activeOfficeId) {
          throw new Error('ID Ufficio non disponibile. Riprova.');
        }

        const officesId = [this.activeOfficeId];
        //const officesId = [loggedUserOrgan.organId];

        //Chiama setTenantUserOffices
        //await this.usersService.setTenantUserOffices(formData.codiceFiscale, newUserId, this.tenantId, officesId).toPromise();
        await this.usersService.setTenantUserOffices(userRequest.userCode, newUserId, this.tenantId, officesId).toPromise()


        // Chiama addUserRoleEELL
        await this.usersService.addUserRoleEELL(newUserId, this.tenantId, this.appId).toPromise();


        //Se tutte le chiamate sequenziali hanno avuto successo
        this.alertsCenterService.showAlert({
          message: `Utente creato e associato con successo.`,
          type: 'success',
          autoClosable: false
        });

        //Reindirizza l'utente
        this.router.navigate(['/gestione-utenti']);

      } catch (error) {
        //Se una qualsiasi delle chiamate sequenziali fallisce, si entra qui.
        this.alertsCenterService.showAlert({
          message: `Si è verificato un errore durante la creazione dell'utente.`,
          type: 'danger',
          autoClosable: false
        });
        console.error('Errore durante la creazione utente:', error);
      } finally {
        this.isLoading = false;
      }
    } else {
      this.alertsCenterService.showAlert({
        message: `Per favore, compila tutti i campi obbligatori.`,
        type: 'danger',
        autoClosable: false
      });
    }
  }


  onReset(): void {
    this.creaUtenteForm.reset();
  }

  onIndietro(): void {
    this.router.navigate(['/gestione-utenti']);
  }
}
